module.exports = __webpack_public_path__ + "img/microphone-slash.b15db4a4.svg";